import React from 'react'
import { Modal } from 'react-bootstrap'

function RTOCompleteModal({ show, vehicleRegistrationNumber, onChangeRegistrationNumber, onClose, onSubmit, saving }) {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Complete RTO Register</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Vehicle Registration Number<span className="text-danger"> *</span></label>
          <input
            type="text"
            className="form-control"
            value={vehicleRegistrationNumber}
            onChange={(e) => onChangeRegistrationNumber(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-cancel" type="button" onClick={onClose} disabled={saving}>Cancel</button>
        <button className="btn btn-submit" type="button" onClick={onSubmit} disabled={saving}>
          {saving ? 'Completing…' : 'Complete'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default RTOCompleteModal